<template>
  <v-app class="app-frame">
    <v-main class="app-main">
      <router-view />
    </v-main>

    <v-snackbar v-model="swUpdateAvailable" :timeout="-1" color="primary" location="bottom">
      Uma nova versão do Trackly está disponível.
      <template #actions>
        <v-btn variant="text" @click="reloadForUpdate">Atualizar</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    swUpdateAvailable: false,
  }),

  mounted() {
    // Disparado por registerServiceWorker.js quando o Workbox baixa uma
    // versao nova do app - sem isso o usuario so descobre que ha uma
    // atualizacao se recarregar a pagina por conta propria.
    document.addEventListener("swUpdated", this.onSwUpdated);
  },

  beforeUnmount() {
    document.removeEventListener("swUpdated", this.onSwUpdated);
  },

  methods: {
    onSwUpdated() {
      this.swUpdateAvailable = true;
    },
    reloadForUpdate() {
      window.location.reload();
    },
  },
};
</script>

<style>
:root {
  --pcse-app-bg: radial-gradient(circle at top left, #eef4f8 0%, #f8fafc 45%, #edf2f7 100%);
  --pcse-surface: rgba(255, 255, 255, 0.94);
  --pcse-border: rgba(22, 50, 74, 0.1);
  --pcse-shadow: 0 24px 70px rgba(13, 31, 46, 0.1);
  --pcse-soft-panel: linear-gradient(160deg, #f7efe4 0%, #e3edf5 100%);
  --pcse-strong-panel: linear-gradient(180deg, #10263a 0%, #1c4462 100%);
  --pcse-drawer-bg: linear-gradient(180deg, #0d1f2e 0%, #17324a 100%);
  --pcse-drawer-border: rgba(255, 255, 255, 0.08);
  --pcse-topbar-bg: rgba(255, 255, 255, 0.78);
  --pcse-text-main: #172635;
  --pcse-text-muted: #5d7284;
}

html,
body,
#app {
  min-height: 100%;
  background: var(--pcse-app-bg);
}

.app-frame,
.app-main,
.v-application {
  background: transparent !important;
  color: var(--pcse-text-main);
}
</style>
